import { InjectionToken } from "@angular/core";
import GridSummariesCustomNeo from "./grid-summaries-custom-neo";

export const GRID_SUMMARIES = {
  filasSummary: GridSummariesCustomNeo.filasSummary,
  customFilasSummary: GridSummariesCustomNeo.customFilasSummary,
  monedaSummary: GridSummariesCustomNeo.monedaSummary,
  porcentajeSummary: GridSummariesCustomNeo.porcentajeSummary,
  importeProgObraSummary: GridSummariesCustomNeo.importeProgObraSummary
} as const;

export type GridSummariesType = typeof GRID_SUMMARIES;

export const GRID_SUMMARIES_TOKEN = new InjectionToken<GridSummariesType>(
  'GRID_SUMMARIES_TOKEN',
  {
    providedIn: 'root',
    factory: () => GRID_SUMMARIES
  }
);
